<app-mu-section-title title="context.massive.newRouting.breadcrumb.title" subTitle="context.massive.newRouting.breadcrumb.subtitle"></app-mu-section-title>
<app-new-routing-create-form 
    [flagList]="flagList"
    [backToDeliveriesFlag]="massiveNewRoutingCreateFlags.BACK_TO_DELIVERIES"
    [continueToCreateServiceFlag]="massiveNewRoutingCreateFlags.CONTINUE_TO_CREATE_SERVICE"
    [formData]="formData"
    [defaultDate]="defaultDate"
    [startDate]="defaultDate"
    >
</app-new-routing-create-form>
<app-mu-loading-modal-dialog [processingData]="processingRoute"></app-mu-loading-modal-dialog>